import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, message, Table, Tag, Form, Checkbox } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import './Page2.css';

import { DatePicker, Space, Button } from 'antd';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';


// import axios from 'axios';
const layout = {
  // labelCol: { span: 10 },
  // wrapperCol: { span: 30 },
}
const tailLayout = {

}

const Demo = () => {
  const onFinish = (values: any) => {
    console.log('Success:', values);
  }
}

const onFinishFailed = (errorInfo: any) => {
  console.log('Failed:', errorInfo);
}

const dateFormat = 'YYYY/MM/DD';
const { Column, ColumnGroup } = Table;

const data = [
  {
    key: '1',
    firstName: 'John',
    lastName: 'Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    firstName: 'Jim',
    lastName: 'Green',
    age: 42,
    address: 'London No. 1 Lake Park',
    tags: ['loser'],
  },
  {
    key: '3',
    firstName: 'Joe',
    lastName: 'Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
    tags: ['cool', 'teacher'],
  },
];

const InquiryDetails: React.FC = (props: any) => {
  const user = JSON.parse(localStorage.getItem("userobject")||'{}');
  const [PropertyObject, setState] = useState({ 
    Status:"",
    Date: "", 
   Email: "",
   PhoneNumber: "",
   ID: "",
   Name: "", 
   OwnerID: "", 
   ClientID: "",
   PropertyID: "", 
   EquipmentStatus: "", 
   EquipmentID: "", 
   EquipmentName: "", 
  
  });
  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setState(prevState => ({
        ...prevState,
        [name]: value
    }));
  
    setState(prevState => ({
     ...prevState,
     userid: user.id
  }));
  };
  
  const handleChangecheckbox = (e: any, name: any) => {
  
    setState(prevState => ({
      ...prevState,
      [name]: e
    }));
  };
  

  const { name } = useParams<{ name: string; }>();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              onBack={()=>{props.history.goBack()}}
              title="Inquiry Details"
            />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen >
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="20" style={{ paddingLeft: "40px" }}>
                <IonCard>
                  <IonCardHeader>

                  </IonCardHeader>

                  <IonCardContent>


                    <Form
                      {...layout}
                      name="basic"
                      initialValues={{ remember: true }}
                      onFinish={Demo}
                      onFinishFailed={onFinishFailed}
                    >

                      <IonRow>
                        <Form.Item
                          label="Status"
                          name="username"
                          rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                          <Input value={PropertyObject.Status} onChange={handleChange}/>
                        </Form.Item>
                        <Form.Item
                          label="ID"
                          name="username"
                          rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                          <Input value={PropertyObject.ID} onChange={handleChange} />
                        </Form.Item>
                      </IonRow>

                      <IonRow>
                        <Form.Item
                          label="Date"
                          name="username"
                          rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                          <Input value={PropertyObject.Date} onChange={handleChange}/>
                        </Form.Item>
                        <Form.Item
                          label="Email"
                          name="username"
                          rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                          <Input value={PropertyObject.Email} onChange={handleChange}/>
                        </Form.Item>
                      </IonRow>
                      <IonRow>
                        <Form.Item
                          label="Phone Number"
                          name="username"
                          rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                          <Input value={PropertyObject.PhoneNumber} onChange={handleChange}/>
                        </Form.Item>
                        <Form.Item
                          label="Name"
                          name="username"
                          rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                          <Input value={PropertyObject.Name} onChange={handleChange}/>
                        </Form.Item>
                      </IonRow>
                      <IonRow>
                        <Form.Item
                          label="Owner ID"
                          name="password"
                          rules={[{ required: true, message: 'Please input your password!' }]}
                        >
                          <Input value={PropertyObject.OwnerID} onChange={handleChange}/>
                        </Form.Item>
                        <Form.Item
                          label="Client ID"
                          name="password"
                          rules={[{ required: true, message: 'Please input your password!' }]}
                        >
                          <Input value={PropertyObject.ClientID} onChange={handleChange}/>
                        </Form.Item>
                      </IonRow>
                      <Form.Item
                        label="Property ID"
                        name="password"
                        rules={[{ required: true, message: 'Please input your password!' }]}
                      >
                        <Input.Password value={PropertyObject.PropertyID} onChange={handleChange}/>
                      </Form.Item>

                      <p>Equipment</p>

                      <IonRow>
                        <Form.Item
                          label="Status"
                          name="password"
                          rules={[{ required: true, message: 'Please input your password!' }]}
                        >
                          <Input value={PropertyObject.EquipmentStatus} onChange={handleChange}/>
                        </Form.Item>
                        <Form.Item
                          label="ID"
                          name="password"
                          rules={[{ required: true, message: 'Please input your password!' }]}
                        >
                          <Input value={PropertyObject.EquipmentID} onChange={handleChange}/>
                        </Form.Item>
                        <Form.Item
                          label="Name"
                          name="password"
                          rules={[{ required: true, message: 'Please input your password!' }]}
                        >
                          <Input value={PropertyObject.EquipmentName} onChange={handleChange}/>
                        </Form.Item>
                      </IonRow>


                      <Form.Item {...tailLayout} name="remember" valuePropName="checked">
                        <Checkbox>Remember me</Checkbox>
                      </Form.Item>



                      <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">
                          Submit
        </Button>
                      </Form.Item>


                    </Form>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>


  );
};

export default InquiryDetails;